export default __webpack_public_path__ + "static/media/2008.337b2e31.png";